
export default {
  data() {
    return {
      selectedValue: ""
    };
  },
  watch: {
    selectedValue(value) {
      this.$router.push(this.switchLocalePath(value));
    }
  },
  computed: {
    links() {
      return [
        { name: this.$t('home'), to: "/" },
        { name: this.$t('prices'), to: "/prices" },
        { name: this.$t('features'), to: "/features" },
        { name: this.$t('storeApp'), to: "/store-app" },
        { name: this.$t('blog'), href: "https://blog.matjrah.com/" },
      ];
    },
  },
  mounted() {
    let referral = this.$route.query.referral;

    if (referral) {
      this.$cookies.set('referral', referral, {
        path: '/',
        maxAge: 60 * 60 * 24 * 60
      })
    }
  },
  created() {
    this.selectedValue = this.$i18n.locale;
  },
  methods: {

  }
};
